import { Box } from '@mui/material'
import Logo from './Logo'

const SlashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: '#141B22',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000,
    }}
  >
    <Logo />
  </Box>
)

export default SlashScreen
